import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=7e551c3e&"
import script from "./Merchandise.vue?vue&type=script&lang=js&"
export * from "./Merchandise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports